import { BORAL_GREEN } from 'Constants/Theme/Theme.constants'
import Colors from 'Support/Theme/Colors/Colors'

const usersListStyles = ({ theme }) => {
  return {
    ellipsis: {
      overflow: `hidden`,
      textOverflow: `ellipsis`,
    },
    infoIcon: {
      color: theme.palette.grey[`400`],
      cursor: `pointer`,
      height: theme.spacing(1) * 3,
      marginLeft: theme.spacing(1) * 1.5,
      verticalAlign: `middle`,
    },
    itemRoot: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    listItemTextRoot: {
      paddingRight: theme.spacing(1) * 9,
    },
    paperRoot: {
      padding: `${theme.spacing(1)}px ${theme.spacing(1) * 0.5}px ${theme.spacing(1)}px ${theme.spacing(1) * 2}px`,
    },
    spinner: {
      height: theme.spacing(1) * 6,
      marginBottom: 0,
      marginTop: 0,
      width: theme.spacing(1) * 6,
    },
    textRow: {
      lineHeight: `1.3rem`,
    },
    userIcon: {
      color: theme.palette.grey[300],
      fontSize: theme.spacing(1) * 6,
    },
    userIconMe: {
      color: Colors.boralgreen[500],
    },
    currentUser: {
      color: BORAL_GREEN,
    },
    tabWrapper: {
      marginBottom: `${theme.spacing(1) * 1.5}px`,
    },
    button: {
      textTransform: 'none',
    },
    listItemWrapper: {
      marginBottom: `${theme.spacing(1) * 1.5}px`,
    },
    superUserChip: {
      background: Colors.raven[900],
      color: '#fff',
    },
    standardUserChip: {
      background: Colors.raven[500],
      color: '#fff',
    },
    rootWrapper: {
      paddingBottom: `${theme.spacing(1) * 10}px`,
    },
  }
}

export default usersListStyles
